exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ColorDetails {\n  border-top: solid 1px #ccc;\n  display: flex;\n  margin-top: 8px;\n  overflow: auto;\n  text-align: center;\n}\n\n.ColorDetails .label {\n  font-size: 12px;\n  padding: 0 5px;\n}\n\n.ColorDetails .color {\n  border-radius: 50%;\n  display: inline-block;\n  height: 10px;\n  width: 10px;\n}\n\n.ColorDetails .tooltip:after {\n  border-top-width: 0;\n}\n", ""]);

// exports
